




































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "docs-search-provider": () =>
      import("@/components/app/global/docs/docsSearchProvider.vue"),
    "docs-search-list": () =>
      import("@/components/app/global/docs/docsSearchList.vue")
  }
})
export default class DocsSearch extends Vue {
  // Props

  @Prop({ default: "" })
  public docsSearchQuery!: string;
}
